module.exports = __webpack_public_path__ + "media/images/badges/akt/milestone-0-Active-AKT-0384314a354031d47d725f875401c0f9.png";